//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AssignWeldPMI",1,0],[1,"Characteristics",0,"Weld.CharacteristicsBuilder",0],[0,"Class4gd",1,0],[1,"SelectBody",0,"SelectDisplayableObjectList",0],[1,"SelectConnectParts",0,"ScCollector",0],[1,"SelectEdge",0,"SelectDisplayableObjectList",0]],[],[]];
SPLM.Weld.UserDefinedWeldBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.UserDefinedWeldBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.UserDefinedWeldBuilder.WeldTypes = Object.freeze({
    "Groove" : "Groove", "Fillet" : "Fillet", "PlugSlot" : "PlugSlot", "Bead" : "Bead", "Fill" : "Fill"});

export default SPLM;